export const currentTimestamp = function (): number {
    const current = new Date();
    return Math.round(current.getTime() / 1000);
};